// Shadows PropertyOption PHP class

/**
 * Property option item
 */
export class PropertyOption{
	/**
	 * Option ID.
	 */
	public id: string;
	/**
	 * Path to icon file.
	 */
	public icon: string = null;
	// public useIcons:boolean = false;

	/**
	 * Option label.
	 */
	public label: string = null;
	/**
	 * Option price.
	 */
	public price: number = null;
	protected value: string = null; // use realValue getter for access this one

	/**
	 * Option variables.
	 */
	public vars: {[id:string]:string} = {};

	/**
	 * List of aliases for current option (parent groups)
	 */
	public alias:string[] = [];

	public composite: string[] = [];

	/**
	 * Additional property user data
	 */
	public userData: {[id:string]:string|number} = null;

	/**
	 * List of compatible product varaints.
	 * Following special chars are supported:
	 * * `?` any single character
	 * * `*` any number of any characters (including zero)
	 */
	public for:string|string[] = null;

	protected _for:RegExp[] = [];

	/**
	 * @hidden
	 */
	constructor(data:{})	// JSON data constructor
	constructor(PropertyOption) // clone constructor
	constructor(data:{}|PropertyOption){
		Object.assign(this, data);

		if (!(data instanceof PropertyOption))
			if (this.for){
				if (Array.isArray(this.for)){
					for (let pattern of this.for)
						this._for.push(PropertyOption.patternToRegexp(pattern));
				}
				else
					this._for.push(PropertyOption.patternToRegexp(this.for));
			}
	}

	/**
	 * Converts object-matching pattern to regexp.
	 * @param {string} pattern
	 * @return {RegExp}
	 */
	protected static patternToRegexp(pattern:string):RegExp{
		// Special characters which could be interpreted as RE special char
		pattern = pattern
			.replace(/([\\.^$+])/g, '\\$1')

		// * and ? are replaced by '.*' and '.'
			.replace(/\*/g, '.*')
			.replace(/\?/g, '.');
		return new RegExp(`^${pattern}$`);
	}

	/**
	 * Real option value (`value` if set, `id` otherwise).
	 */
	get realValue():string{
		return String(this.value
			? this.value
			: this.id);
	}

	/**
	 * Deteremines whteher option rules matches productID.
	 * @param productID Product ID
	 * @return {boolean} True when matches
	 */
	match(productID:string = null):boolean{
		if (!this.for || this.for === '*')
			return true;
		if (!productID)	// expose all options when no product is selected
			return true;
		for(let re of this._for)
			if (productID.match(re))
				return true;
		return false;
	}



	/**
	 * List of IDs matching to this option (includes actual value, all aliases and `*`).
	 */
	get matchingIDs(): string[] {
		return ['*', this.realValue, ...this.alias];
	}
}


// WEBPACK FOOTER //
// ./src/script/app3D/data/PropertyOption.ts